export const mutations = {
  addInvoiceProduct(state) {
    state.invoice_products.push({
      description: "",
      qty: "",
      unit_price: "",
      total: ""
    });
  },
  STORE_INVOICES(state, invoices){
    state.invoices = invoices
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/mutations.js